import { SeriesDetailsState } from './state';
import { SeriesDetailsActionsType, SeriesDetailsActionsUnion } from './actions';
import { DealActionsUnion } from '../deal/actions';
import { DEFAULT_MARGINAL_TAX_RATE } from '../../types/user-preferences.types';

export const initialSeriesDetailsState: SeriesDetailsState = {
  defaultMarginalTaxRateValue: DEFAULT_MARGINAL_TAX_RATE,
  margTaxRate: undefined
};

export function seriesDetailsReducer(
  state: SeriesDetailsState = initialSeriesDetailsState,
  action: SeriesDetailsActionsUnion | DealActionsUnion
): SeriesDetailsState {
  switch (action.type) {
    case SeriesDetailsActionsType.SetMargTaxRate: {
      const res = {
        ...state,
        margTaxRate: {
          ...(state.margTaxRate || {}),
          ...action.payload
        }
      };
      return res;
    }
    default:
      return state;
  }
}

export const getMargTaxRate = (state: SeriesDetailsState) => state.margTaxRate;
export const getDefaultMargTaxRateValue = (state: SeriesDetailsState) =>
  state.defaultMarginalTaxRateValue;
